/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { NotificationsSocialUploadNotificationDataDto } from "./NotificationsSocialUploadNotificationDataDto";

export const NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnum = {
    "social-export_upload-completed": "social-export_upload-completed"
} as const;

export type NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnumKey = (typeof NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnum)[keyof typeof NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnum];

export type NotificationsSocialUploadCompletedNotificationDto = {
    /**
     * @description Knock workflow key. Map from the feed item source.key; not part of trigger data.
     * @type string
    */
    workflowKey: NotificationsSocialUploadCompletedNotificationDtoWorkflowKeyEnumKey;
    /**
     * @description In-app notification data for social-export_upload-completed and social-export_upload-failed
     * @type object
    */
    data: NotificationsSocialUploadNotificationDataDto;
};